<template>
    <header class="dashHeader">
        <img :src="imageURL" class="dashMainImg dashOffset"/>
        <div class="dashMainInfo">
            <div class="dashInfoPrimary">
                <h1 class="dashPrimaryTitle">{{name}}</h1>
            </div>
            <div class="dashInfoSecondary">
                <p v-if="owner" class="dashSecondaryItem"> {{owner}} </p>
                <p v-if="dockID" class="dashSecondaryItem"> Dock ID: {{dockID}} </p>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'berth-header',
    data: () => ({
        name: "Berth",
        owner: "",
        dockID: 0,
        imageURL: "/logo.png"
    }),
    methods: {
        updateInfo: function({name="Berth", owner="", dockID = 0}) {
            var globv = this;
            globv.name = name;
            globv.owner = owner;
            globv.dockID = dockID;

            // TODO: Some try catch pinging an image of the dock itself
        },
        reset: function() {
            var globv = this;
            globv.name = "Berth";
            globv.owner = "";
            globv.dockID = 0;
            globv.imageURL = "/logo.png"
        }
    }
}
</script>

<style lang="scss">
.dashHeader {
    display: flex;
    justify-content: flex-start;
    padding: 10px;
    background-color: #2f55a4;
    color: white;
    background-color: var(--primaryColor);
    color: var(--primaryTextColor);
    margin-bottom: 5rem;
}

.dashOffset {
    margin-left: 15%;
}

.dashMainImg {
    height: 10rem; 
    background-color: white;
    margin-bottom: -5rem;
}

.dashMainInfo {
    display: flex;
    flex-direction: column;
    padding: 5px;
    margin: 0 10px;
    min-width: 237px;
}

.dashInfoPrimary {
    font-size: 1.5rem;
    display: flex;
    padding: 5px 0;
    align-items: center;
}

.dashPrimaryTitle {
    font-weight: bold;
    margin: 0 1.5rem 0 0;
}

.dashFlag {
    height: 2rem;
}

.dashInfoSecondary {
    font-size: 0.9rem;
    display: flex;
}

.dashSecondaryItem {
    margin-right: 20px;
}

@media (max-width: 1350px) {
    .dashOffset {
        margin-left: 0;
    }
}

@media (max-width: 780px) {
    .dashInfoSecondary {
        flex-direction: column;
    }

    .dashHeader {
        margin-bottom: 4rem;
    }
}

@media (max-width: 580px) {
    .dashInfoPrimary {
        flex-direction: column;
        align-items: flex-start;
    }

    .dashMainImg {
        margin-bottom: 0;
    }

    .dashHeader {
        margin-bottom: 0;
    }
}

@media (max-width: 500px) {
    .dashHeader {
        flex-direction: column;
    }

    .dashMainImg {
        margin-bottom: 5px;
        width: 100%;
        height: auto;
    }

    .dashFlag {
        height: 5rem;
    }

    .dashInfoPrimary, .dashInfoSecondary {
        align-items: center;
    }

    .dashInfoSecondary {
        font-size: 1rem;
    }
}
</style>
